import React, { useEffect, useState } from "react";
import { Modal, Image, Tag, Input } from "antd";
import toast from "react-hot-toast";
import "../utils/validate.css";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import { ApprovedtransferBank, getProofDocument, rejectTransferBank } from "../services/developerApi";
const DetailRechargeBank = ({isOpen,developer, onRefresh,
  modal,
  setModal,
  toggle,
  selectedBusiness,
  onReject,
}) => {
  const [loadingAction, setLoadingAction] = useState(false);
  const [showRejectInput, setShowRejectInput] = useState(false);
  const [reason, setReason] = useState("");
  const [proofDocument, setProofDocument] = useState(null);
  useEffect(() => {
  if (!selectedBusiness?.id) return;

  const fetchProof = async () => {
    try {
      const response = await getProofDocument(
        selectedBusiness?.id,
        true,
        developer?.apiKey,
        developer?.apiToken
      );

      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setProofDocument(url);
    } catch (error) {
      console.log(error);
    }
  };

  fetchProof();
}, [selectedBusiness?.id]);
  const handleDownload = () => {
  if (!proofDocument) return;
  const link = document.createElement("a");
  link.href = proofDocument;
  link.download = "recu.pdf";
  link.click();
};
  if (!selectedBusiness) return null;

 const handleValidate = async () => {
  try {
    setLoadingAction(true);

    await ApprovedtransferBank(
      selectedBusiness?.id,
      "Recharge validée par admin",
      developer?.apiKey,
      developer?.apiToken
    );
    await onRefresh();
    toast.success("Recharge validée");

    toggle();

  } catch (error) {

    toast.error(
      error?.response?.data?.message ||
      "Erreur validation"
    );

  } finally {
    setLoadingAction(false);
  }
};
 const handleReject = async () => {
  try {
    setLoadingAction(true);

    await rejectTransferBank(
      selectedBusiness?.id,
      {
        reason:
          reason ||
          "Le PDF du virement est illisible, merci d'envoyer une capture nette ou un nouveau justificatif.",
      },
      developer?.apiKey,
      developer?.apiToken
    );
    await onRefresh();
    toast.success("Recharge rejetée");

    toggle();

  } catch (error) {

    console.log("🔴 ERROR REJECT:", error?.response?.data || error);

    toast.error(
      error?.response?.data?.message ||
      "Erreur rejet"
    );

  } finally {
    setLoadingAction(false);
  }
};
const getStatus = (status) => {
  switch (status) {
    case "APPROVED":
      return { label: "Confirmé", color: "#349C32",bg:'#EBFFEA' };
   case "PENDING_REVIEW":
     return {
    label: "En attente de validation",
    color: "#7B2CBF",
    bg: "#FBF3FF"
  };

    case "SUCCESS":
      return { label: "Succés", color: "#349C32",bg:'#EBFFEA' };

    case "REJECTED":
       return { label: "Rejeté", color: "#D41C1C",bg:'#FFF0F0' };
    case "WAITING_PROOF":
      return {
    label: "Documents requis",
    color: "#000000",
     bg: "#F6F6F6",
  };

    default:
      return { label: status, color: "default" };
  }
};
const statusInfo = getStatus(selectedBusiness?.status);
  return (
    <Modal
      open={isOpen}
      onCancel={toggle}
      footer={null}
      centered
      width={500}
      className="modal-validate"
    >
      <div className="validate-modal-content">

        <div className="validate-title">
          Demande de rechargement
        </div>
        <div style={{display: "flex",justifyContent: "center",alignItems: "center"}}>
          <img
            src={selectedBusiness?.merchantAvatar || defaultAvatar}
            alt="merchant"
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              objectFit: "cover",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        </div>
        <span className="marchand">
          {selectedBusiness?.merchantAccountName}
        </span>
        <div className="cli">Client</div>
       <div className="mb-3"
      style={{ display: "flex",
      justifyContent: "center",
      alignItems: "center"
     }}>
 <Tag
  style={{
    backgroundColor: statusInfo.bg,
    color: statusInfo.color,
    border: `1px solid ${statusInfo.bg}`,
    fontSize: "14px",
    width: "50%",
    padding: "14px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 12,
    fontWeight:"600px",
    fontFamily:'Poppins'
  }}
>
  {statusInfo.label}
</Tag>
</div>
  <div style={{textAlign: "left"}} className="reef">
    Référence
  </div>
  <div
    style={{
      width: "100%",
      background: "#F6F6F6",
      padding: "10px",
      borderRadius: "12px",
      display: "flex",
      justifyContent: "center",
    }}
  >
    <div className="info-reef"
      style={{
        textAlign: "left",
        width: "100%",
      }}
    >
      {selectedBusiness?.transactionReference}
    </div>
  </div>

        <div
          style={{
            marginTop: 20,
            border: "1px solid #EAEAEA",
            borderRadius: 12,
            padding: 10,
            background: "#FAFAFA",
          }}
        >
          <div
            style={{
              marginBottom: 10,
              fontWeight: 500,
            }}
          >
            Justificatif de paiement
          </div>

          {selectedBusiness?.proofFilePath ? (
            <Image
              src={selectedBusiness?.proofFilePath}
              style={{
                width: "100%",
                maxHeight: 300,
                objectFit: "contain",
                borderRadius: 10,
              }}
            />
          ) : (
            <div
              style={{
                padding: 30,
                textAlign: "center",
                color: "#999",
              }}
            >
              Aucun justificatif disponible
            </div>
          )}
        </div>

        {/* BUTTONS */}
      {/* ACTIONS */}
<div
  style={{
    marginTop: 25,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  }}
>

  {/* SI EN ATTENTE DE VALIDATION */}
  {selectedBusiness?.status === "PENDING_REVIEW" && (
    <>
      <button className="button-valid"
        onClick={handleValidate}
        disabled={loadingAction}
      >
        {loadingAction
          ? "Validation..."
          : "Valider le rechargement"}
      </button>

      <button className="button-reject"
        onClick={() => setShowRejectInput(true)}
        disabled={loadingAction}
      >
        Rejeter la demande
      </button>
    </>
  )}
  {(selectedBusiness?.status === "APPROVED" ||
    selectedBusiness?.status === "SUCCESS") && (
    <div className="demandeApproved"
    >
      Demande déjà approuvée
    </div>
  )}
  {selectedBusiness?.status === "WAITING_PROOF" && (
    <div className="demandeProof"
    >
      Renseigner les documents
    </div>
  )}
  {selectedBusiness?.status === "REJECTED" && (
    <div className="demandeReject">
      Cette demande a été rejetée
    </div>
  )}
  {showRejectInput && (
  <div style={{ marginTop: 10 }}>
    <Input.TextArea
      placeholder="Motif du rejet..."
      value={reason}
      onChange={(e) => setReason(e.target.value)}
      rows={4}
      style={{
        borderRadius: 10,
      }}
    />
    <button className="confirm-reject"
      style={{
       marginTop: 10,
      }}
      onClick={handleReject}
      disabled={loadingAction}
    >
      Confirmer le rejet
    </button>
  </div>
)}
</div>
</div>
</Modal>
  );
};
export default DetailRechargeBank;